// extracted by mini-css-extract-plugin
export var attributes = "index-module--attributes--sSlUp";
export var col = "index-module--col--C1KF4";
export var container = "index-module--container--dbhj9";
export var description = "index-module--description--11G0r";
export var distributorContainer = "index-module--distributorContainer--StKe+";
export var info = "index-module--info--pGm7x";
export var logo = "index-module--logo--RfNBJ";
export var logoContainer = "index-module--logoContainer--jSw8c";
export var name = "index-module--name--WIUds";
export var row = "index-module--row--fnfuW";
export var title = "index-module--title--MbbCD";
export var wrapper = "index-module--wrapper--2o7Iz";